import axios from 'axios';

export default {
    namespaced: true,
    state: {
        deactiveListings: null,
        loadingDeactiveListings: false
    },
    getters: {
        deactiveListingsCount(state) {
            return state.deactiveListings
                ? state.deactiveListings.length
                : null;
        }
    },
    mutations: {
        startLoading(state) {
            state.loadingDeactiveListings = true;
        },

        resetDeactiveListing(state) {
            state.deactiveListings = null;
        },
        updateDeactiveListings(state, data) {
            state.deactiveListings = data;
            state.loadingDeactiveListings = false;
        }
    },
    actions: {
        getDeactiveListings({ commit }) {
            commit('resetDeactiveListing');
            commit('startLoading');
            axios
                .get('/deactive-listings')
                .then(result => {
                    commit('updateDeactiveListings', result.data.data);
                })
                .catch(console.error);
        }
    }
};
